angular.module('bmsApp.employee')
	.controller('EmployeeSaveCtrl', [
		'$scope',
		'$state',
		'$q',
		'notify',
		'FormOptionsSvc',
		'EmployeeSvc',
		'EmployeeOptionsSvc',
		'$timeout',
		'SiteSvc',
		'LicenseOptionsSvc',
		'InstanceSvc',
		function ($scope,
				  $state,
				  $q,
				  notify,
				  FormOptionsSvc,
				  EmployeeSvc,
				  EmployeeOptionsSvc,
				  $timeout,
				  SiteSvc,
				  LicenseOptionsSvc,
				  InstanceSvc) {

			$scope.myImage = '';
			$scope.profileImage = '';
			$scope.ecomEnabled = InstanceSvc.instance.ecomEnabled();
			var handleFileSelect = function (evt) {
				var file = evt.currentTarget.files[0];
				var reader = new FileReader();
				reader.onload = function (evt) {
					$scope.$apply(function ($scope) {
						$scope.myImage = evt.target.result;
					});
				};
				reader.readAsDataURL(file);
				$scope.imageSelected = true;
			};
			angular.element(document.querySelector('#fileInput'))
				.on('change', handleFileSelect);

			$scope.customColorOptions = {
				size: 30,
				total: 26,
				customColors:  ['#FFFFFF', '#F49AC2', '#CB99C9', '#C23B22', '#FFD1DC', '#DEA5A4', '#AEC6CF', '#77DD77', '#CFCFC4', '#B39EB5', '#FFB347', '#B19CD9', '#FF6961', '#03C03C', '#FDFD96', '#836953', '#779ECB', '#966FD6', '#7bd148', '#5484ed', '#a4bdfc', '#46d6db', '#7ae7bf', '#51b749', '#fbd75b', '#ffb878', '#ff887c', '#dc2127', '#dbadff', '#e1e1e1'],
				roundCorners: true
			};

			$scope.formvalidatorconfig = {
				submitHandler: function (form) {
					$scope.submit($scope.employee);
				},
				errorPlacement: function (error, element) {
					error.appendTo('#employee-errors');
				},
				errorContainer: '#employee-errors'
			};

			if(!$scope.isCS() && !$scope.isRB()){
				$scope.requiredFields = [
					'title',
					'full_name',
					'surname',
					'gender',
					'birth_date',
					'address_1',
					'city',
					'county',
					'postcode',
					'employee_role',
					'start_date',
					'employee_status',
					'employment_type',
					'remuneration_type',
					'notice',
					'employee_payment_period',
					'holiday',
					'ni_number',
					'tax_code',
				];
			}else{
				$scope.requiredFields = [
					'full_name',
					'surname',
					'email',
					'employee_number',
					'employee_status',
				];
			}

			$scope.isRequiredField = function(fieldName){
				if($scope.requiredFields.indexOf(fieldName) !== -1) {
					return true;
				}
				return false;
			};

			// updating or creating
			$scope.updating = $state.current.name == 'main.employee.index.view.update';
			// show loader
			$scope.loading = true;
			$scope.processing = false;
			// blank employee
			$scope.employee = {
				own_car: false, // preset so that 'N' gets filled for new record
				valid_docs: false, // preset so that 'N' gets filled for new record
				pay_rate: 0,
				clean_rate: 0,
				travel_rate: 0,
				percentage: 0,
				minimum_hourly_rate: 0,
				paysettings_effective_from: moment()
					.add(1, 'days')
					.format('YYYY-MM-DD'),
				increase_low_percentages: false,
				start_time: '09:00',
				end_time: '17:00',
				part_time_days: {// preset weekdays
					monday: true,
					tuesday: true,
					wednesday: true,
					thursday: true,
					friday: true
				}
			};
			// options promises for selects / checklists
			titleOptionsPromise = FormOptionsSvc.title();
			genderOptionsPromise = FormOptionsSvc.gender();
			startingLocationTypeOptionsPromise = FormOptionsSvc.startingLocationType();
			employeeOptionsAllPromise = EmployeeOptionsSvc.all();
			licenseOptionsPromise = LicenseOptionsSvc.license();
			var promises = [
				titleOptionsPromise,
				genderOptionsPromise,
				startingLocationTypeOptionsPromise,
				employeeOptionsAllPromise,
				licenseOptionsPromise
			];
			// push employee promise if updating a record
			if ($scope.updating) {
				employeePromise = EmployeeSvc.read($state.params.employeeId);
				promises.push(employeePromise);
			}
			// I promise this works
			$q.all(promises)
				.then(function (data) {
					// loading finished, populate options
					$scope.loading = false;
					$scope.titleOptions = data[0].data.options;
					$scope.genderOptions = data[1].data.options;
					$scope.startingLocationTypeOptions = data[2].data.options;
					$scope.employeeRoleOptions = data[3].employeeRole.options;
					$scope.employeeStatusOptions = data[3].employeeStatus.options;
					$scope.employmentTypeOptions = data[3].employmentType.options;
					$scope.remunerationTypeOptions = data[3].remunerationType.options;
					$scope.employeePaymentPeriodOptions = data[3].employeePaymentPeriod.options;
					$scope.employeeMileageRateOptions = data[3].employeeMileageRate.options;
					$scope.employeeGroupOptions = data[3].employeeGroups.group_options;
					$scope.licenseOptions = data[4].data.options;
					// populate employee scope when updating
					if ($scope.updating) {
						angular.extend($scope.employee, data[5].data.employee);
					}
				});
			// compare non-identical license objects
			$scope.employeeLicenseComparator = function (obj1, obj2) {
				return typeof obj1 !== 'undefined' && typeof obj2 !== 'undefined' && obj1.id === obj2.id;
			};

			$scope.onEmployeeStatusChanged = function () {
				if ($scope.employee.employee_status.id === 2) {
					$scope.employee.end_date = moment()
						.format('YYYY-MM-DD');
				}
				else {
					$scope.employee.end_date = null;
				}
			};

			$scope.addressLookup = function() {
				return SiteSvc.lookup({postcode: $scope.employee.postcode_lookup, houseNo: $scope.employee.houseno_lookup}).then(function(response) {
					$scope.addressList = response.data.addresses;
					if ($scope.addressList.length === 1) {
						let address = $scope.addressList[0];
						$scope.employee.address_1 = address.line_1 || '';
						$scope.employee.address_2 = address.line_2 || '';
						$scope.employee.address_3 = address.line_3 || '';
						$scope.employee.city = address.city || '';
						$scope.employee.county = address.county || '';
						$scope.employee.postcode = address.postcode || '';
						$scope.employee.showLookup = false;
					}
				}, function() {
					notify({
						message: 'Address not found',
						classes: 'error',
					});
				});
			};

			$scope.addressChanged = function(address) {
				$scope.employee.address_1 = address.line_1;
				$scope.employee.address_2 = address.line_2;
				$scope.employee.address_3 = address.line_3;
				$scope.employee.city = address.city;
				$scope.employee.county = address.county;
				$scope.employee.postcode = address.postcode;
				$scope.employee.showLookup = false;
			};

			// handle form submission
			$scope.submit = function (employee) {
				$scope.processing = true;
				if ($scope.imageSelected) {
					angular.extend(employee, {
						profilePic: $scope.profileImage
					});
				}

				var savePromise = $scope.updating ? EmployeeSvc.update(employee.id, employee) : EmployeeSvc.create(employee);

				savePromise
					.then(function (response) {
						notify({
							message: $scope.updating ? 'Employee updated successfully' : 'Employee created successfully'
						});
						$state.go('main.employee.index.view', {
							employeeId: response.data.employee.id
						});
					}, function (error) {
						$scope.errors = error;
					})
					.finally(function () {
						$scope.processing = false;
					});
			};

		}
	]);
